import { SCREEN_SIZES } from '@/shared/config/ui';

const SIDE_ELEMENT_SIZE_PHONE = 80;
const SIDE_ELEMENT_SIZE_TABLET = 110;
const SIDE_ELEMENT_SIZE_DESKTOP = 180;

const INBOARD_OFFSET_PHONE = 46;
const INBOARD_OFFSET_DESKTOP = 78;

const INITIAL_LIFT_Y_PHONE = -50;
const INITIAL_LIFT_Y_TABLET = -70;
const INITIAL_LIFT_Y_DESKTOP = -90;

const JUMP_HEIGHT_PHONE = 200;
const JUMP_HEIGHT_TABLET = 250;
const JUMP_HEIGHT_DESKTOP = 300;

type ResponsiveWidthPx = {
	mobile: number;
	tablet: number;
	desktop: number;
};

export function getResponsiveWidthPx(screenWidth: number, widths: ResponsiveWidthPx): number {
	if (screenWidth >= SCREEN_SIZES.LARGE_DESKTOP) {
		return widths.desktop;
	}

	if (screenWidth >= SCREEN_SIZES.DESKTOP) {
		return widths.tablet;
	}

	return widths.mobile;
}

export function computeInitialLiftYFromWidth(screenWidth: number): number {
	if (screenWidth < SCREEN_SIZES.DESKTOP) {
		return INITIAL_LIFT_Y_PHONE;
	}
	if (screenWidth < SCREEN_SIZES.LARGE_DESKTOP) {
		return INITIAL_LIFT_Y_TABLET;
	}
	return INITIAL_LIFT_Y_DESKTOP;
}

export function getSideElementSizePx(screenWidth: number): number {
	if (screenWidth < SCREEN_SIZES.DESKTOP) {
		return SIDE_ELEMENT_SIZE_PHONE;
	}
	if (screenWidth < SCREEN_SIZES.LARGE_DESKTOP) {
		return SIDE_ELEMENT_SIZE_TABLET;
	}
	return SIDE_ELEMENT_SIZE_DESKTOP;
}

export function getInboardOffsetPx(screenWidth: number): number {
	return screenWidth < SCREEN_SIZES.DESKTOP ? INBOARD_OFFSET_PHONE : INBOARD_OFFSET_DESKTOP;
}

export function getInboardOffsetScale(screenWidth: number): number {
	return getInboardOffsetPx(screenWidth) / INBOARD_OFFSET_DESKTOP;
}

export function getCharacterJumpHeightPx(screenWidth: number): number {
	if (screenWidth < SCREEN_SIZES.DESKTOP) {
		return JUMP_HEIGHT_PHONE;
	}
	if (screenWidth < SCREEN_SIZES.LARGE_DESKTOP) {
		return JUMP_HEIGHT_TABLET;
	}
	return JUMP_HEIGHT_DESKTOP;
}
